import { useDirectusItems } from "#imports";
import { ref } from "vue";
export const useFetchMenuData = async () => {
  const { getItems } = useDirectusItems();
  const menuData = ref([]);
  const fetchDataMenu = async (data) => {
    if (data) {
      menuData.value = data;
    } else {
      menuData.value = await getItems({
        collection: "menus",
        params: {
          fields: ["*", "menu_items.*"]
        }
      }).then((res) => {
        return res;
      }).catch((e) => {
        console.warn("[NuxtCommonUI] Cant read or not existed!", e);
        return [];
      });
    }
  };
  return { fetchDataMenu, menuData };
};
